<template>
  <b-container>
    <h2 class="text-left title mb-5">
      Főkategória szerkesztése
    </h2>
    <form @submit="handleSubmit">
      <div role="group" class="input-wrapper my-4 col-md-8 col-lg-6">
        <label for="title">Főkategória neve</label>
        <b-form-input
          id="title"
          v-model="title"
          :state="titleState"
          aria-describedby="title-live-feedback"
          placeholder="Adja meg a főkategória nevét"
          trim
        ></b-form-input>

        <!-- This will only be shown if the preceding input has an invalid state -->
        <b-form-invalid-feedback id="input-live-feedback">
          Legalább 5 karakter hosszú
        </b-form-invalid-feedback>

        <!-- This is a form text block (formerly known as help block) -->
        <!-- <b-form-text id="input-live-help">Főkategória neve</b-form-text> -->
      </div>

      <div class="input-wrapper mb-4">
        <label>Válasszon ikont a kategóriához</label>
        <b-row class="py-2 icon-row">
          <div v-for="icon in availableIcons" :key="icon" class="text-center">
            <font-awesome-icon
              :icon="icon"
              :class="`icon ${icon === selectedIcon ? 'selected' : ''}`"
              @click="handleIconSelect(icon)"
            />
          </div>
        </b-row>
      </div>

      <div class="input-wrapper">
        <label>Válasszon alkategóriákat</label>
        <SubCategorySelector
          @new-selected-sub-categories="handleSubCatSelection"
          :subCategories="subCategories"
          :preSelection="this.cachedCategory.subCategories.map(category => category._id)"
        />
      </div>

      <b-row class="px-3 pb-4 mt-3">
        <b-button @click="() => this.$router.back()" class="col-12 col-xl-2 col-lg-2 col-md-2 col-sm-2 mr-2 mb-2"
          >Vissza</b-button
        >
        <b-button
          class="col-12 col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-2"
          :disabled="!titleState || !iconState || !subCategoriesState"
          variant="primary"
          type="submit"
          >Kategória mentése</b-button
        >
      </b-row>
    </form>
  </b-container>
</template>

<script>
import { patchMainCategory, getAllSubCategories } from '../../../api/fundMapCategories'
import { mapGetters } from 'vuex'
import iconsForCategories from '../../../constants/iconsForCategories'
import SubCategorySelector from '../../../components/SubCategorySelector.vue'
export default {
  components: {
    SubCategorySelector
  },
  computed: {
    ...mapGetters(['cachedCategory']),
    titleState() {
      if (!this.titleTouched) return null
      return this.title.length > 4
    },
    iconState() {
      return this.selectedIcon.length > 0
    },
    subCategoriesState() {
      return this.selectedSubCategories.length > 0
    }
  },
  data() {
    return {
      title: '',
      titleTouched: false,
      selectedIcon: '',
      selectedSubCategories: [],
      subCategories: [],
      availableIcons: iconsForCategories
    }
  },
  methods: {
    handleSubCatSelection(categories) {
      this.selectedSubCategories = categories
    },
    async handleSubmit(e) {
      e.preventDefault()
      try {
        await patchMainCategory(this.cachedCategory._id, {
          title: this.title,
          icon: this.selectedIcon,
          subCategories: this.selectedSubCategories
        })

        this.$router.push('/fund-categories')
      } catch (e) {
        console.log('Patching main category error')
      }
    },
    handleIconSelect(iconStr) {
      if (iconStr === this.selectedIcon) {
        this.selectedIcon = ''
      } else {
        this.selectedIcon = iconStr
      }
    },
    selectSubCategory(_id) {
      if (this.selectedSubCategories.includes(_id)) {
        this.selectedSubCategories = this.selectedSubCategories.filter(id => id !== _id)
      } else {
        this.selectedSubCategories.push(_id)
      }
    },
    goBack(e) {
      e.preventDefault()
      this.$store.dispatch('setCategoryCacheAction', null)
      this.$router.back('/fund-categories')
    }
  },
  watch: {
    title() {
      this.titleTouched = true
    }
  },
  async created() {
    try {
      const subCategories = await getAllSubCategories()
      this.subCategories = subCategories
    } catch (e) {
      console.log('Sub categories fetch error')
      this.subCategories = []
    }
    this.title = this.cachedCategory.title
    this.selectedIcon = this.cachedCategory.icon
    this.selectedSubCategories = this.cachedCategory.subCategories.map(category => category._id)
  }
}
</script>
<style scoped>
.title {
  font-size: 36px;
  font-weight: 800;
}
.sub-category-list-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px 48px;
  border-radius: 8px;
  border: 1px solid #b2bec3;
  color: #00903c;
  cursor: pointer;
  font-weight: 700;
  font-size: 20px;
}
.sub-category-list-item.selected {
  background-color: #00903c;
  color: #fff;
}

.icon-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  padding: 10px;
}

.icon {
  font-size: 25px;
  padding: 15px;
  color: #28a745;
  border-radius: 50%;
  border: 1px solid #28a745;
  cursor: pointer;
  transition: all 0.2s;
  width: 25px;
}

.icon.selected {
  background-color: #28a745;
  color: #fff;
  border: 1px solid #fff;
  transform: scale(1.2);
}

.icon:hover {
  transform: scale(1.2);
}
.input-wrapper {
  padding-inline: 0;
}
.input-wrapper > * {
  text-align: left !important;
  font-size: 16px;
}
.input-wrapper label {
  width: 100%;
  padding: 0;
  color: #000;
  font-weight: 700;
  font-size: 12px;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .title {
    font-size: 48px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1440px) {
  .title {
    font-size: 56px;
  }
}
@media screen and (min-width: 1200px) {
  .sub-category-list-item {
    font-size: 24px;
  }
}
@media screen and (min-width: 1440px) {
  .title {
    font-size: 64px;
  }
}
</style>
